import { Box, CircularProgress, Grid } from "@mui/material";
import { DocumentReferenceResponse } from "api/generatedApi";
import { ThumbnailEntry, useExtraWorkAgreementThumbnails } from "../hooks/use-extra-work-agreement-thumbnails";
import { ThumbnailFrame } from "./thumbnailFrame";

interface Props {
  projectId: string;
  agreementId: string;
  documents: DocumentReferenceResponse[];
  pendingUploads: File[];
  canDelete?: boolean;
  onDeleteSaved?: (document: DocumentReferenceResponse) => void;
  onDeletePending?: (file: File) => void;
}

export const ThumbnailGrid = ({
  projectId,
  agreementId,
  documents,
  pendingUploads,
  canDelete = false,
  onDeleteSaved,
  onDeletePending,
}: Props) => {
  const { thumbnails, isLoading } = useExtraWorkAgreementThumbnails({
    projectId,
    agreementId,
    documents,
    pendingUploads,
  });

  if (isLoading && thumbnails.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", pt: 2 }}>
        <CircularProgress size={30} />
      </Box>
    );
  }

  if (thumbnails.length === 0) {
    return null;
  }

  const handleDelete = (entry: ThumbnailEntry) => {
    if (entry.pendingFile) {
      onDeletePending?.(entry.pendingFile);
      return;
    }
    if (entry.documentId) {
      const doc = documents.find((d) => d.documentId === entry.documentId);
      if (doc) onDeleteSaved?.(doc);
    }
  };

  return (
    <Grid container spacing={2} sx={{ pt: 2 }}>
      {thumbnails.map((entry) => (
        <Grid item key={entry.key} xs={12} sm={6} md={4}>
          <ThumbnailFrame
            entry={entry}
            size="100%"
            canDelete={canDelete}
            onDelete={handleDelete}
          />
        </Grid>
      ))}
    </Grid>
  );
};
